export type WorkspaceRequestIdParams = Partial<{
  requestCreatorId: string;
  workspaceId: string;
}>;

export const N_DEVICE_FREE_VERSION = 1;
